import { takeEvery, put, select } from 'redux-saga/effects'
import { isEmpty, prop, isNil, length } from 'ramda'
import {
  createSystemNotification,
  deleteSystemNotification,
} from 'actions/application'
import {
  POWER_TAKE_OFF_RECEIVED,
  UPDATE_FRAGMENTS_SUCCESS,
  UPDATE_FRAGMENTS_FAIL,
  CREATE_PTO_TEMPLATE_SUCCESS,
  CREATE_PTO_TEMPLATE_FAIL,
} from 'actions/powerTakeOff'
import {
  UPDATE_EXM,
  ADD_EXM,
  ADD_EXM_FAILURE_NOTIFY,
  ADD_XMC,
  ADD_XMC_SUCCESS_NOTIFY,
  DOWNLOAD_PAR_FILE_SUCCESS,
  GET_TRUCK_DETAILS,
  VEHICLE_CONTAINS_OBSOLETE_FEATURE,
  ADD_XMC_FAILURE_NOTIFY,
} from 'actions/truck'
import {
  FEATURE_SAVED,
  FEATURE_SAVE_FAILED,
  MERGE_DONOR_LOGIC,
  FEATURE_CREATED,
  OBSOLETE_FEATURE_SAVED,
} from 'actions/feature/features'
import {
  DUPLICATE_REFERENCE_PARAM,
  EDIT_REFERENCE_PARAMETER,
} from 'actions/referenceParameter'
import { RPWF_FINISHED_COMMIT_NOTIFICATION } from 'actions/addReferenceParametersWorkflow'
import {
  EDIT_SUPPORT_PARAM,
  DUPLICATE_SUPPORT_PARAM,
} from 'actions/supportParameter'
import {
  ENTER_SIMULATE_MODE,
  exitSimulateMode,
} from 'actions/feature/simulation'
import { SET_IS_EDITING } from 'actions/navigator'
import {
  ECP_MODULE_UPDATED,
  ECP_MODULES_STATE_RECEIVED,
  LOAD_ECP_PAGE,
  ADD_ECP,
  ECP_MODULE_UPDATE_FAILED_NOTIFY,
  OPTIONAL_SOLENOIDS_NOT_INSTALLED as OPTIONAL_SOLENOIDS_ACTION,
} from 'actions/ecp'
import {
  NOTIFICATION_INFO,
  NOTIFICATION_WARNING,
  NOTIFICATION_SUCCESS,
  NOTIFICATION_DROPDOWN,
  NOTIFICATION_ERROR,
  ADD_COMPONENTS_WITHOUT_LOCATION_BANNER,
  FEATURE,
} from 'utils/constants'
import {
  PTO_PENDING_UPDATE,
  UPDATE_EXM_NOTIFY,
  SIMULATION_NOTIFY,
  ADD_EXM_NOTIFY,
  ADD_EXM_FAILURE_NOTIFY as ADD_EXM_FAILURE_NOTIFY_ID,
  EDIT_RP_NOTIFY,
  EDIT_FEATURE_NOTIFY,
  EDIT_SP_NOTIFY,
  PTO_SAVE_FAIL_NOTIFY,
  getFragmentId,
  getErrorDetail,
  FEATURE_LOGIC_MERGED,
  ECP_PENDING_UPDATE,
  SNG_PENDING_UPDATE,
  PAR_FILE_DOWNLOAD_NOTIFY,
  PTO_SAVE_TEMPLATE_NOTIFY,
  FEATURE_CREATE_NOTIFY,
  COMMIT_RP_TO_VEHICLE_ERROR_NOTIFY,
  COMMIT_RP_TO_VEHICLE_SUCCESS_NOTIFY,
  ECUS_ADD_XMC_SUCCESS_NOTIFY,
  ECUS_ADD_XMC_WARNING_NOTIFY,
  ECP_ADD_WARNING_NOTIFY,
  PRE_PROD_READ_ONLY_LEAD,
  PRE_PROD_READ_ONLY_NONLEAD,
  ECP_PENDING_MULTIPLE_UPDATES,
  OPTIONAL_SOLENOIDS_NOT_INSTALLED,
  ECUS_ADD_XMC_FAILURE_NOTIFY,
} from 'utils/notifications'
import {
  getPendingDomains,
  getFragment,
  getFragmentDomainName,
} from 'selectors/powerTakeOff'
import {
  getOptionalSolenoids,
  makeGetPendingModuleSlotSelector,
  getEcpActiveSerialNumber,
} from 'selectors/ecp'
import { getFeatureMetadata } from 'selectors/feature/featureMetadata'

import {
  DISPLAY_ALLIUM_DATA_BANNER,
  DISPLAY_PARTS_WITHOUT_LOCATION_BANNER,
  LOAD_SNG_PAGE,
  SAVE_LAYOUT_LOCATION,
  SAVED_WITH_ALLIUM_ERRORS_BANNER,
  SUCCESS_DASH_CONFIG,
  SUCCESS_SAVE_APPROVED_LAYOUT,
  SUCCESS_SAVE_DASH_CONFIG,
  SUCCESS_SAVE_LAYOUT_LOCATION,
} from 'actions/dash'
import { selectIsPartPendingList, getDashSerialNumber } from 'selectors/dash'
import React from 'react'
import strings from 'utils/strings'
import PreProdNonLeadMessage from 'components/notifications/PreProdNonLeadMessage'

// Navigation-only actions that don't change data - skip delete+create cycle
// These just ensure the notification is visible, the actual data comes from SUCCESS_* actions
const NAVIGATION_ONLY_ACTIONS = [
  LOAD_SNG_PAGE,
  LOAD_ECP_PAGE,
  ECP_MODULES_STATE_RECEIVED,
]

const bannerDictionary = {
  [POWER_TAKE_OFF_RECEIVED]: showPendingPtoUpdates,
  [UPDATE_FRAGMENTS_SUCCESS]: showPendingPtoUpdates,
  [UPDATE_FRAGMENTS_FAIL]: handleFragmentsSavedFail,
  [UPDATE_EXM]: showUpdateExmNotification,
  [ENTER_SIMULATE_MODE]: handleEnterSimulateMode,
  [ADD_EXM]: showAddExmNotification,
  [ADD_EXM_FAILURE_NOTIFY]: showAddExmFailedNotification,
  [ADD_XMC_SUCCESS_NOTIFY]: showAddXmcNotification,
  [ADD_XMC_FAILURE_NOTIFY]: showAddXmcFailedNotification,
  [ECP_MODULE_UPDATE_FAILED_NOTIFY]: showAddXmcFailedNotification,
  [ADD_XMC]: showUpdateXmcNotification,
  [ECP_MODULE_UPDATED]: showPendingEcpUpdates,
  [ECP_MODULES_STATE_RECEIVED]: showPendingEcpUpdates,
  [LOAD_ECP_PAGE]: showPendingEcpUpdates,
  [OPTIONAL_SOLENOIDS_ACTION]: showPendingEcpUpdates,
  [DUPLICATE_REFERENCE_PARAM]: showRpEditNotification,
  [EDIT_REFERENCE_PARAMETER]: showRpEditNotification,
  [SET_IS_EDITING]: showFeatureEditNotification,
  [EDIT_SUPPORT_PARAM]: showSpEditNotification,
  [DUPLICATE_SUPPORT_PARAM]: showSpEditNotification,
  [DISPLAY_ALLIUM_DATA_BANNER]: showAlliumDataNotification,
  [SAVED_WITH_ALLIUM_ERRORS_BANNER]: showSavedWithAlliumErrorsNotification,
  [DISPLAY_PARTS_WITHOUT_LOCATION_BANNER]:
    sAndGpartsWithoutLocationNotification,
  [FEATURE_CREATED]: showFeatureCreationNotification,
  [SUCCESS_DASH_CONFIG]: pendingSwitchAndGaugeNotification,
  [SUCCESS_SAVE_DASH_CONFIG]: pendingSwitchAndGaugeNotification,
  [LOAD_SNG_PAGE]: pendingSwitchAndGaugeNotification,
  [MERGE_DONOR_LOGIC]: donorLogicMerged,
  [DOWNLOAD_PAR_FILE_SUCCESS]: downloadParFileSuccessNotification,
  [RPWF_FINISHED_COMMIT_NOTIFICATION]: commitRPToVehicle,
  [CREATE_PTO_TEMPLATE_SUCCESS]: showTemplateSaveSuccess,
  [CREATE_PTO_TEMPLATE_FAIL]: showTemplateSaveFail,
  [ADD_ECP]: addEcp,
  [GET_TRUCK_DETAILS]: showPreProdWarning,
  [FEATURE_SAVED]: getFeatureSaved,
  [OBSOLETE_FEATURE_SAVED]: getObsoleteFeatureSaved,
  [VEHICLE_CONTAINS_OBSOLETE_FEATURE]: vehicleContainsObsoleteFeature,
  [FEATURE_SAVE_FAILED]: handleFeatureSaveFailed,
  [SUCCESS_SAVE_LAYOUT_LOCATION]: handleSaveLayoutLocation,
  [SUCCESS_SAVE_APPROVED_LAYOUT]: handleSaveApprovedLayout,
}

// For banner notifications, pass persistent prop as true(otherwise they will be treated as toasts).
function* getBannerInfoFromAction(action) {
  const { type } = action
  const actionHandler = bannerDictionary[type]
  return yield actionHandler(action)
}

export default function* watchAllBannerNotifications() {
  yield takeEvery(Object.keys(bannerDictionary), watchForBannerNotifications)
}

export function* watchForBannerNotifications(action) {
  const bannerInfo = yield getBannerInfoFromAction(action)
  if (bannerInfo && !isEmpty(bannerInfo)) {
    const { notificationId, notificationFormat, closable } = bannerInfo
    // For dropdown banners and closable banners, delete before create to refresh data.
    // Closable banners must be refreshed so a second trigger always shows the notification
    // even if the user hasn't manually dismissed the previous one yet.
    // BUT skip delete for navigation-only actions (LOAD_SNG_PAGE, LOAD_ECP_PAGE)
    // These don't change data, they just ensure notification visibility
    // The reducer's duplicate check will handle them - avoids unnecessary state churn
    const isNavigationOnly = NAVIGATION_ONLY_ACTIONS.includes(action.type)
    if (
      (notificationFormat === NOTIFICATION_DROPDOWN || closable) &&
      !isNavigationOnly
    ) {
      yield put(deleteSystemNotification({ notificationId }))
    }
    yield put(createSystemNotification(bannerInfo))
  }
}

function* donorLogicMerged({ donorFeatureId }) {
  const donorFeatureMeta = yield select(getFeatureMetadata, {
    featureId: donorFeatureId,
  })
  const { partNumber } = donorFeatureMeta || {}

  return {
    notificationMessage: `${strings.imported_feature} ${partNumber}`,
    persistent: true,
    closable: true,
    notificationType: NOTIFICATION_SUCCESS,
    notificationId: FEATURE_LOGIC_MERGED,
  }
}

function* showPendingPtoUpdates() {
  const pendingFragments = yield select(getPendingDomains)

  if (isEmpty(pendingFragments)) {
    return {}
  }

  const pendingCount = pendingFragments.reduce(
    (acc, fragment) => acc + prop('pendingCount', fragment),
    0
  )

  const notificationData = {
    header: strings.pto_alert_header(pendingCount, strings.pending_pto_updates),
    title: `${strings.pending_changes}:`,
    body: pendingFragments,
  }
  return {
    notificationMessage: notificationData,
    notificationType: NOTIFICATION_WARNING,
    persistent: true,
    notificationId: PTO_PENDING_UPDATE,
    async: false,
    closable: false,
    notificationFormat: NOTIFICATION_DROPDOWN,
  }
}

function* handleFragmentsSavedFail(action) {
  const { description } = action
  const fragmentId = getFragmentId(description)
  const errorDetail = getErrorDetail(description)
  const fragment = yield select(getFragment, { id: fragmentId })
  const fragmentDomain = yield select(getFragmentDomainName, { id: fragmentId })
  const { name } = fragment
  const errorMessage = strings.pto_error_banner_message(
    fragmentDomain,
    name,
    errorDetail
  )
  if (isNil(fragmentDomain) || isNil(name)) return {}
  return {
    notificationMessage: errorMessage,
    notificationType: NOTIFICATION_ERROR,
    persistent: true,
    closable: true,
    notificationId: PTO_SAVE_FAIL_NOTIFY,
  }
}

function showUpdateExmNotification(action) {
  const { size } = action
  return {
    notificationMessage: strings.insure_upgrade_installed(size),
    notificationType: NOTIFICATION_WARNING,
    persistent: true,
    notificationId: UPDATE_EXM_NOTIFY,
    async: false,
    closable: true,
  }
}

function showUpdateXmcNotification() {
  return {
    notificationMessage: strings.add_xmc_warning_message_on_success,
    notificationType: NOTIFICATION_WARNING,
    persistent: true,
    notificationId: ECUS_ADD_XMC_WARNING_NOTIFY,
    async: false,
    closable: true,
  }
}

function handleEnterSimulateMode() {
  return {
    notificationMessage: strings.simulator_mode_banner,
    notificationType: NOTIFICATION_INFO,
    persistent: true,
    notificationId: SIMULATION_NOTIFY,
    async: null,
    closable: false,
    description: null,
    redirect: null,
    actionTrigger: {
      text: strings.exit_simulator_mode,
      onClick: exitSimulateMode,
      needsDispatch: true,
    },
  }
}

function showAddExmNotification(action) {
  const { moduleName } = action
  return {
    notificationMessage: strings.exm_added_on_vehicle(moduleName),
    notificationType: NOTIFICATION_SUCCESS,
    persistent: false,
    notificationId: ADD_EXM_NOTIFY,
    async: false,
    closable: true,
  }
}

function showAddExmFailedNotification(action) {
  const { moduleName } = action
  return {
    notificationType: NOTIFICATION_ERROR,
    persistent: true,
    notificationId: ADD_EXM_FAILURE_NOTIFY_ID,
    notificationMessage: `Failed to add ${moduleName || 'EXM'} module.`,
    closable: true,
  }
}

function showAddXmcNotification(action) {
  const { modules } = action

  const msg = `${modules
    .slice(0, modules.length > 1 ? modules.length - 1 : 1)
    .map((item) => item.name)
    .join(', ')}${strings.add_xmc_success_message(
    modules.length > 1 ? modules[modules.length - 1].name : null
  )}`

  return {
    notificationMessage: msg,
    notificationType: NOTIFICATION_SUCCESS,
    persistent: true,
    notificationId: ECUS_ADD_XMC_SUCCESS_NOTIFY,
    async: false,
    closable: true,
  }
}
function showAddXmcFailedNotification() {
  return {
    notificationMessage: strings.vehicle_add_xmc_failed_message,
    notificationType: NOTIFICATION_ERROR,
    persistent: true,
    notificationId: ECUS_ADD_XMC_FAILURE_NOTIFY,
    async: false,
    closable: true,
  }
}

export function* showPendingEcpUpdates() {
  // Guard: ensure ECP state belongs to the vehicle currently in the URL.
  // When navigating between vehicles, loadEcpPage fires before the new
  // vehicle's ECP data has loaded — the selectors still hold stale data.
  const ecpSerialNumber = yield select(getEcpActiveSerialNumber)
  const pathMatch = window.location.pathname.match(/\/vehicles\/([^/]+)/)
  const urlSerialNumber = pathMatch ? pathMatch[1] : null

  if (
    ecpSerialNumber &&
    urlSerialNumber &&
    ecpSerialNumber.toUpperCase() !== urlSerialNumber.toUpperCase()
  ) {
    // Stale state — clear any existing ECP notifications and bail out.
    // The correct notification will be created once ECP_MODULES_STATE_RECEIVED
    // fires for the new vehicle and the optional-solenoid action dispatches.
    yield put(deleteSystemNotification({ notificationId: ECP_PENDING_UPDATE }))
    yield put(
      deleteSystemNotification({ notificationId: ECP_PENDING_MULTIPLE_UPDATES })
    )
    yield put(
      deleteSystemNotification({
        notificationId: OPTIONAL_SOLENOIDS_NOT_INSTALLED,
      })
    )
    return {}
  }

  let pendingSlots = yield select(makeGetPendingModuleSlotSelector)
  let optionalSolenoids = yield select(getOptionalSolenoids)

  // Reconcile the full ECP notification family — only one variant should
  // exist at a time. Clear all before creating the applicable one.
  yield put(deleteSystemNotification({ notificationId: ECP_PENDING_UPDATE }))
  yield put(
    deleteSystemNotification({ notificationId: ECP_PENDING_MULTIPLE_UPDATES })
  )
  yield put(
    deleteSystemNotification({
      notificationId: OPTIONAL_SOLENOIDS_NOT_INSTALLED,
    })
  )

  // API's pending flag is the single source of truth - no sessionStorage fallback needed
  if (isEmpty(pendingSlots) && isEmpty(optionalSolenoids)) return {}

  // Sum pendingCount from each ECP module for accurate total
  // Each ECP's pendingCount now reflects its actual slot change count (from selector fix)
  const ecpUpdatesCount = pendingSlots.reduce(
    (total, ecpData) => total + (prop('pendingCount', ecpData) || 0),
    0
  )

  const optionalSolenoidsCount = new Set(
    optionalSolenoids.flatMap((item) => item.solenoidId)
  ).size

  const pendingCount = ecpUpdatesCount + optionalSolenoidsCount

  let notificationData = {
    header: `${strings.pending_pneumatics_updates} (${pendingCount})`,
    alertHeader: {
      [ECP_PENDING_UPDATE]: `${strings.pneumatics_has_pending_banner} (${ecpUpdatesCount})`,
      [OPTIONAL_SOLENOIDS_NOT_INSTALLED]: `${strings.pneumatics_has_optional_solenoids_banner} (${optionalSolenoidsCount})`,
    },
    title: {
      [ECP_PENDING_UPDATE]: strings.pneumatics_ecp_pending_changes,
      [OPTIONAL_SOLENOIDS_NOT_INSTALLED]:
        strings.pneumatics_optional_solenoids_title,
    },
    body: {
      [ECP_PENDING_UPDATE]: pendingSlots,
      [OPTIONAL_SOLENOIDS_NOT_INSTALLED]: optionalSolenoids,
    },
  }

  let notificationId = ECP_PENDING_MULTIPLE_UPDATES

  if (!isEmpty(pendingSlots) && isEmpty(optionalSolenoids)) {
    notificationData = {
      header: `${strings.pneumatics_has_pending_banner} (${pendingCount})`,
      title: notificationData.title[ECP_PENDING_UPDATE],
      body: notificationData.body[ECP_PENDING_UPDATE],
    }
    notificationId = ECP_PENDING_UPDATE
  } else if (isEmpty(pendingSlots) && !isEmpty(optionalSolenoids)) {
    notificationData = {
      header: `${strings.pneumatics_has_optional_solenoids_banner} (${pendingCount})`,
      title: notificationData.title[OPTIONAL_SOLENOIDS_NOT_INSTALLED],
      body: notificationData.body[OPTIONAL_SOLENOIDS_NOT_INSTALLED],
    }
    notificationId = OPTIONAL_SOLENOIDS_NOT_INSTALLED
  }

  return {
    notificationMessage: notificationData,
    notificationType: NOTIFICATION_WARNING,
    persistent: true,
    notificationId,
    async: false,
    closable: false,
    notificationFormat: NOTIFICATION_DROPDOWN,
    showOnPaths: ['/vehicles/.*/pneumatics'],
  }
}

function addEcp() {
  return {
    notificationMessage: strings.add_ecp_warning,
    notificationType: NOTIFICATION_WARNING,
    persistent: true,
    notificationId: ECP_ADD_WARNING_NOTIFY,
    async: false,
    closable: false,
  }
}

function showRpEditNotification() {
  return {
    notificationMessage: strings.editing_reference_param,
    notificationType: NOTIFICATION_INFO,
    notificationId: EDIT_RP_NOTIFY,
    persistent: true,
  }
}

export function showFeatureCreationNotification() {
  return {
    notificationMessage: strings.feature_created,
    notificationType: NOTIFICATION_SUCCESS,
    persistent: true,
    notificationId: FEATURE_CREATE_NOTIFY,
    async: false,
    closable: true,
  }
}

function showFeatureEditNotification(action) {
  const { isEditing, entity = FEATURE } = action
  if (!isEditing || entity !== FEATURE) return {}
  return {
    notificationMessage: strings.editing_feature,
    notificationType: NOTIFICATION_INFO,
    notificationId: EDIT_FEATURE_NOTIFY,
    persistent: true,
  }
}

function showSpEditNotification() {
  return {
    notificationMessage: strings.editing_param,
    notificationType: NOTIFICATION_INFO,
    notificationId: EDIT_SP_NOTIFY,
    persistent: true,
  }
}

function sAndGpartsWithoutLocationNotification() {
  return {
    persistent: true,
    closable: true,
    notificationMessage: strings.components_without_locations,
    notificationId: ADD_COMPONENTS_WITHOUT_LOCATION_BANNER,
    notificationType: NOTIFICATION_WARNING,
  }
}

function showAlliumDataNotification() {
  return {
    persistent: true,
    closable: true,
    notificationMessage: strings.displaying_allium_data,
    notificationId: DISPLAY_ALLIUM_DATA_BANNER,
    notificationType: NOTIFICATION_INFO,
  }
}

function showSavedWithAlliumErrorsNotification() {
  return {
    persistent: true,
    closable: true,
    notificationMessage: strings.saved_with_allium_errors,
    notificationId: DISPLAY_ALLIUM_DATA_BANNER,
    notificationType: NOTIFICATION_WARNING,
  }
}

function* pendingSwitchAndGaugeNotification() {
  // Get the serial number from Redux state (the vehicle whose data is currently loaded)
  const reduxSerialNumber = yield select(getDashSerialNumber)

  // Get the serial number from the URL (the vehicle the user is trying to view)
  const pathMatch = window.location.pathname.match(/\/vehicles\/([^/]+)/)
  const urlSerialNumber = pathMatch ? pathMatch[1] : null

  // Don't show notification if Redux state is for a different vehicle than the URL
  // This prevents stale notifications from showing when navigating between vehicles
  if (
    reduxSerialNumber &&
    urlSerialNumber &&
    reduxSerialNumber.toUpperCase() !== urlSerialNumber.toUpperCase()
  ) {
    return {}
  }

  const pendingParts = yield select(selectIsPartPendingList)

  // API's pendingEdexUpdate flag is the single source of truth - no sessionStorage fallback needed
  if (isEmpty(pendingParts)) {
    return {}
  }

  // Use list length for accurate count (matches expanded display)
  const pendingCount = length(pendingParts)
  const header = `${strings.pending_sng_updates} (${pendingCount})`
  const notificationData = {
    header,
    title: `${strings.pending_changes}:`,
    body: pendingParts,
  }
  return {
    notificationMessage: notificationData,
    notificationType: NOTIFICATION_WARNING,
    persistent: true,
    notificationId: SNG_PENDING_UPDATE,
    async: false,
    closable: false,
    notificationFormat: NOTIFICATION_DROPDOWN,
  }
}

function downloadParFileSuccessNotification({ serialNumber }) {
  return {
    notificationMessage: strings.par_file_download_success(serialNumber),
    notificationType: NOTIFICATION_SUCCESS,
    persistent: true,
    notificationId: PAR_FILE_DOWNLOAD_NOTIFY,
    closable: true,
    showIcon: false,
    icon: 'alert_banner_success_check',
  }
}

function commitRPToVehicle(action) {
  const { code } = action
  if (code < 200 || code >= 300) {
    const { errorMessage: message } = action
    return {
      notificationMessage: strings.added_reference_parameters_error(
        code,
        message
      ),
      notificationType: NOTIFICATION_ERROR,
      notificationId: COMMIT_RP_TO_VEHICLE_ERROR_NOTIFY,
      persistent: true,
      description: false,
      closable: true,
    }
  }

  return {
    notificationMessage: strings.added_reference_parameters,
    notificationType: NOTIFICATION_SUCCESS,
    notificationId: COMMIT_RP_TO_VEHICLE_SUCCESS_NOTIFY,
    persistent: true,
    closable: true,
  }
}

function showTemplateSaveSuccess(action) {
  const { templateName } = action

  return {
    notificationMessage: strings.pto_template_save_success(templateName),
    notificationType: NOTIFICATION_SUCCESS,
    notificationId: PTO_SAVE_TEMPLATE_NOTIFY,
    persistent: true,
    closable: true,
  }
}

function showTemplateSaveFail(action) {
  const { actionArguments: { templateName } = {} } = action

  return {
    notificationMessage: strings.pto_template_save_fail(templateName),
    notificationType: NOTIFICATION_ERROR,
    notificationId: PTO_SAVE_TEMPLATE_NOTIFY,
    persistent: true,
    closable: true,
  }
}

export function* showPreProdWarning(vehicle) {
  const { isPreProduction, isLeadSerial, leadSerialNumber } = vehicle.data

  // Always clear both pre-prod notifications first so that navigating from a
  // pre-prod vehicle to a non-pre-prod vehicle (or between two pre-prod vehicles)
  // never leaves a stale banner behind.
  yield put(
    deleteSystemNotification({ notificationId: PRE_PROD_READ_ONLY_LEAD })
  )
  yield put(
    deleteSystemNotification({ notificationId: PRE_PROD_READ_ONLY_NONLEAD })
  )

  if (!isPreProduction) {
    return null
  }
  if (isLeadSerial) {
    return {
      notificationMessage: strings.pre_prod_warning_lead,
      persistent: true,
      closable: false,
      notificationType: NOTIFICATION_INFO,
      notificationId: PRE_PROD_READ_ONLY_LEAD,
      hideOnPaths: [/switchandgauge/, /dash-layout/],
    }
  }
  return {
    notificationMessage: (
      <PreProdNonLeadMessage leadSerialNumber={leadSerialNumber} />
    ),
    persistent: true,
    closable: false,
    notificationType: NOTIFICATION_INFO,
    notificationId: PRE_PROD_READ_ONLY_NONLEAD,
    hideOnPaths: [/dash-layout/],
  }
}

function getFeatureSaved() {
  return {
    notificationMessage: strings.changes_to_this_feature_have_been_saved,
    notificationType: NOTIFICATION_SUCCESS,
    notificationId: FEATURE_SAVED,
    persistent: true,
    closable: true,
  }
}

function getObsoleteFeatureSaved() {
  return {
    notificationMessage:
      strings.changes_to_this_feature_status_as_obsolete_saved,
    notificationType: NOTIFICATION_INFO,
    notificationId: OBSOLETE_FEATURE_SAVED,
    persistent: true,
  }
}

function vehicleContainsObsoleteFeature(action) {
  const { onClick } = action
  return {
    notificationMessage: strings.vehicle_contains_obsolete_features,
    notificationType: NOTIFICATION_WARNING,
    notificationId: VEHICLE_CONTAINS_OBSOLETE_FEATURE,
    persistent: true,
    actionTrigger: {
      text: strings.update_features,
      onClick,
    },
  }
}

function handleFeatureSaveFailed(action) {
  const { description } = action
  return {
    notificationMessage: description
      ? strings.save_failed_with_description(description)
      : strings.save_failed,
    notificationType: NOTIFICATION_ERROR,
    persistent: true,
    closable: true,
  }
}

function handleSaveLayoutLocation() {
  return {
    notificationMessage: strings.this_location_has_been_updated,
    notificationType: NOTIFICATION_SUCCESS,
    notificationId: SAVE_LAYOUT_LOCATION,
    persistent: true,
    closable: true,
  }
}

function handleSaveApprovedLayout() {
  return {
    notificationMessage: strings.switch_and_gauge_update_complete,
    notificationType: NOTIFICATION_SUCCESS,
    notificationId: SAVE_LAYOUT_LOCATION,
    persistent: true,
    closable: true,
  }
}
